module.exports = __webpack_public_path__ + "images/vectorFooterImage.1bb17e33.svg";